import { FC, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { ITransferListItem } from "@miplatform/types";
import { simpleSort } from "@miplatform/utils";
import { TransferList } from "@mibuildweb/components";
import { useDepartments } from "@mibuildweb/hooks";
import { ConfigAccordionHeader } from "../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IOrderTemplateForm } from "../ConfigOrderTemplates.types";

export const OrderDepartmentTabView: FC<DepartmentTabViewProps> = ({
  form,
  extraTabProps: { isReadOnly } = {},
}) => {
  const { getValues, setValue } = form;
  const { departments } = getValues();
  const { getDepartments, departments: allDepartments } = useDepartments();

  useEffect(() => {
    getDepartments();
  }, []);

  const availableDepartments: ITransferListItem[] = allDepartments.map((d) => ({
    ...d,
    key: d.id,
    title: d.name || "",
  }));

  const selectedDepartments: ITransferListItem[] = departments
    .sort((a, b) => simpleSort(a.name, b.name))
    .map((d) => ({
      ...d,
      key: d.id,
      title: d.name || "",
    }));

  const handleAddItem = (key: string) => {
    const selectedDept = allDepartments.find((d) => d.id === key);
    if (!selectedDept) {
      return;
    }
    const updatedDepartments = [...departments, selectedDept];
    setValue("departments", updatedDepartments, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const handleRemoveItem = (key: string) => {
    const updatedDepartments = departments.filter((d) => d.id !== key);
    setValue("departments", updatedDepartments, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <ConfigAccordionHeader title="Department Selection">
      <TransferList
        availableItems={availableDepartments}
        selectedItems={selectedDepartments}
        onAddItem={handleAddItem}
        onRemoveItem={handleRemoveItem}
        availableTitle="Departments"
        selectedTitle="Selected Departments"
        disabled={isReadOnly}
      />
    </ConfigAccordionHeader>
  );
};

interface DepartmentTabViewProps {
  form: UseFormReturn<IOrderTemplateForm>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}
